import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from "interfaces/paginate-duck";
import { IDocumentCategory } from "interfaces/document-category";
const { Types, Creators } = createActions(
  {
    request: ["query"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "PAGINATE_DOCUMENT_CATEGORY_" }
);

export interface PaginateDocumentCategoryState extends IState {
  data: IDocumentCategory[] | Record<string, any>[];
}

const INITIAL_STATE: PaginateDocumentCategoryState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginateDocumentCategoryState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginateDocumentCategoryState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginateDocumentCategoryState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginateDocumentCategory = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateDocumentCategoryTypes = Types;
export const PaginateDocumentCategoryActions = Creators;
